import React from "react";

const styles = {
    pTag: "text-sm font-semibold xl:text-md 2xl:text-lg",
    h2Tag: "text-[#333333] text-3xl font-bold"
}

const HeadingPart = ({ heading, text, order_1 }) => {
  return (
    <div>
      <p className={order_1 ===1 ? styles.pTag.concat(" text-tertiary") : styles.pTag.concat(" text-primary")}>{text}</p>
      <h2 className={styles.h2Tag}>
        {heading}
      </h2>
    </div>
  );
};

export default HeadingPart;
